// packages/world-model/src/traits/diggable/index.ts

export * from './diggableTrait.js';
